module.exports = __webpack_public_path__ + "img/audit.afbcf50e.svg";